const form = document.getElementById("customerInterestsForm");
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const submitButton = document.getElementById("customerInterestsSubmit");

const thumbsUpIcon = `<svg class="checkbox-button-icon" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
        <path d="M20.22 9.55C19.79 9.04 19.17 8.75 18.5 8.75H14.47V6C14.47 4.48 13.24 3.25 11.64 3.25C10.94 3.25 10.31 3.67 10.03 4.32L7.49 10.25H5.62C4.31 10.25 3.25 11.31 3.25 12.62V18.39C3.25 19.69 4.32 20.75 5.62 20.75H17.18C18.27 20.75 19.2 19.97 19.39 18.89L20.71 11.39C20.82 10.73 20.64 10.06 20.21 9.55H20.22ZM5.62 19.25C5.14 19.25 4.75 18.86 4.75 18.39V12.62C4.75 12.14 5.14 11.75 5.62 11.75H7.23V19.25H5.62ZM17.92 18.63C17.86 18.99 17.55 19.25 17.18 19.25H8.74V11.15L11.41 4.9C11.45 4.81 11.54 4.74 11.73 4.74C12.42 4.74 12.97 5.3 12.97 5.99V10.24H18.5C18.73 10.24 18.93 10.33 19.07 10.5C19.21 10.67 19.27 10.89 19.23 11.12L17.91 18.62L17.92 18.63Z" fill="#000000"/>
        </svg>`;

const thumbsDownIcon = `<svg class="checkbox-button-icon" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
        <path d="M18.38 3.25H6.81C5.72 3.25 4.79 4.03 4.6 5.11L3.29 12.61C3.18 13.27 3.36 13.94 3.78 14.45C4.21 14.96 4.83 15.25 5.5 15.25H9.53V18C9.53 19.52 10.76 20.75 12.36 20.75C13.06 20.75 13.69 20.33 13.97 19.68L16.51 13.75H18.39C19.7 13.75 20.76 12.69 20.76 11.38V5.61C20.76 4.31 19.7 3.25 18.39 3.25H18.38ZM15.26 12.85L12.59 19.1C12.55 19.19 12.46 19.26 12.27 19.26C11.58 19.26 11.03 18.7 11.03 18.01V13.76H5.5C5.27 13.76 5.07 13.67 4.93 13.5C4.78 13.33 4.73 13.11 4.77 12.88L6.08 5.38C6.14 5.02 6.45001 4.76 6.82 4.76H15.26V12.85ZM19.25 11.38C19.25 11.86 18.86 12.25 18.38 12.25H16.77V4.75H18.38C18.86 4.75 19.25 5.14 19.25 5.61V11.38Z" fill="#000000"/>
        </svg>`;

const neutralIcon = `<svg class="checkbox-button-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" width="20px" height="20px" viewBox="0 0 36 36" version="1.1" preserveAspectRatio="xMidYMid meet">
        <path d="M24.05,22.06h-12a1,1,0,0,0,0,2h12a1,1,0,0,0,0-2Z" class="clr-i-outline clr-i-outline-path-1"/><path d="M18,2A16,16,0,1,0,34,18,16,16,0,0,0,18,2Zm0,30A14,14,0,1,1,32,18,14,14,0,0,1,18,32Z" class="clr-i-outline clr-i-outline-path-2"/><circle cx="25.16" cy="14.28" r="1.8" class="clr-i-outline clr-i-outline-path-3"/><circle cx="11.16" cy="14.28" r="1.8" class="clr-i-outline clr-i-outline-path-4"/>
        <rect x="0" y="0" width="36" height="36" fill-opacity="0"/>
        </svg>`;

async function fetchInterests() {
  try {
    const response = await fetch(
      "//suomalainen-test.myshopify.com/cdn/shop/t/62/assets/customer-interests-list.json?v=82154908039763485851714379064"
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching interests data:", error);
    document.getElementById("submission-feedback-error").style.display =
      "block";
    document.getElementById("customerInterestsSubmit").disabled = true;
    return null;
  }
}

function showGenericError() {
  submitButton.disabled = true;
  document.getElementById("generic-error-message").style.display = "block";
  setTimeout(() => {
    window.location.href = "/";
  }, 5000);
}

function showSubmissionError() {
  document.getElementById("submission-feedback-error").style.display = "block";
  setTimeout(() => {
    window.location.href = "/";
  }, 5000);
}

if (urlParams.has("cb") || Shopify.designMode == true) {
  // If Custobar cb token parameter exists. (Shopify.designMode == true to prevent the redirect on the theme editor.)
  fetchInterests().then((interests) => {
    if (interests) {
      buildInterestsForm(interests);
    } else {
      console.log("Failed to fetch interests data");
      showGenericError();
    }
  });
} else {
  // No Custobar cb token
  showGenericError();
}

function buildInterestsForm(interests) {
  for (const interest of interests) {
    const categoryDiv = document.createElement("div");
    categoryDiv.setAttribute("class", "category");

    // Add buttons for each category
    const categoryButtonsDiv = document.createElement("div");
    categoryButtonsDiv.setAttribute("class", "category-buttons");

    const loadingSpan = document.createElement("span");
    loadingSpan.setAttribute("class", "animated-loading");
    categoryButtonsDiv.appendChild(loadingSpan);

    const interestName = document.createElement("h3");
    interestName.textContent = interest.name;
    interestName.classList.add("category-title");
    categoryButtonsDiv.appendChild(interestName);

    // Add counter spans for interests, not-interests, and neutral
    const counterSpan = document.createElement("span");
    counterSpan.setAttribute("class", "counter");
    const interestsSpan = document.createElement("span");
    interestsSpan.classList.add("counter-interested");
    const neutralSpan = document.createElement("span");
    neutralSpan.classList.add("counter-neutral");
    const notInterestsSpan = document.createElement("span");
    notInterestsSpan.classList.add("counter-not-interested");
    counterSpan.appendChild(interestsSpan);
    counterSpan.appendChild(neutralSpan);
    counterSpan.appendChild(notInterestsSpan);
    categoryButtonsDiv.appendChild(counterSpan);

    categoryDiv.appendChild(categoryButtonsDiv);

    const fieldset = document.createElement("fieldset");

    const subCategoriesDiv = document.createElement("div");
    subCategoriesDiv.setAttribute(
      "class",
      "sub-categories interests-subcategories"
    );

    for (const subCategory of interest.subCategories) {
      const subFieldset = document.createElement("fieldset");

      const interestedInput = document.createElement("input");
      interestedInput.setAttribute(
        "class",
        "interests-subcategory checkbox-button interested"
      );
      interestedInput.setAttribute("type", "checkbox");
      interestedInput.setAttribute("name", subCategory.dataString);
      interestedInput.setAttribute("value", "interested");
      interestedInput.setAttribute(
        "id",
        `${subCategory.displayString
          .toLowerCase()
          .replace(/ /g, "")}_interested`
      );
      subFieldset.appendChild(interestedInput);

      const interestedLabel = document.createElement("label");
      interestedLabel.setAttribute(
        "for",
        `${subCategory.displayString
          .toLowerCase()
          .replace(/ /g, "")}_interested`
      );
      interestedLabel.innerHTML = thumbsUpIcon;
      subFieldset.appendChild(interestedLabel);

      const neutralInput = document.createElement("input");
      neutralInput.setAttribute(
        "class",
        "interests-subcategory checkbox-button neutral"
      );
      neutralInput.setAttribute("type", "checkbox");
      neutralInput.setAttribute("name", subCategory.dataString);
      neutralInput.setAttribute("value", "neutral");
      neutralInput.setAttribute(
        "id",
        `${subCategory.displayString.toLowerCase().replace(/ /g, "")}_neutral`
      );
      subFieldset.appendChild(neutralInput);

      const neutralLabel = document.createElement("label");
      neutralLabel.setAttribute(
        "for",
        `${subCategory.displayString.toLowerCase().replace(/ /g, "")}_neutral`
      );
      neutralLabel.innerHTML = neutralIcon;
      subFieldset.appendChild(neutralLabel);

      const notInterestedInput = document.createElement("input");
      notInterestedInput.setAttribute(
        "class",
        "interests-subcategory checkbox-button not-interested"
      );
      notInterestedInput.setAttribute("type", "checkbox");
      notInterestedInput.setAttribute("name", subCategory.dataString);
      notInterestedInput.setAttribute("value", "not_interested");
      notInterestedInput.setAttribute(
        "id",
        `${subCategory.displayString
          .toLowerCase()
          .replace(/ /g, "")}_not_interested`
      );
      subFieldset.appendChild(notInterestedInput);

      const notInterestedLabel = document.createElement("label");
      notInterestedLabel.setAttribute(
        "for",
        `${subCategory.displayString
          .toLowerCase()
          .replace(/ /g, "")}_not_interested`
      );
      notInterestedLabel.innerHTML = thumbsDownIcon;
      subFieldset.appendChild(notInterestedLabel);

      const subLegend = document.createElement("span");
      subLegend.textContent = subCategory.displayString;
      subLegend.classList.add("subcategory-title");
      subFieldset.appendChild(subLegend);

      subCategoriesDiv.appendChild(subFieldset);
    }

    fieldset.appendChild(subCategoriesDiv);
    categoryDiv.appendChild(fieldset);
    form.appendChild(categoryDiv);
    const categoryDivs = document.querySelectorAll(".category");
    categoryDivs.forEach((div) => {
      setTimeout(() => {
        div.classList.add("loaded");
      }, 500);
    });

    // Update counters based on selected subcategories
    const subCategoryInputs = categoryDiv.querySelectorAll(
      '.interests-subcategory[type="checkbox"]'
    );
    subCategoryInputs.forEach((input) => {
      input.addEventListener("change", () => {
        // Uncheck the other input when one is checked
        const otherOptions = input.parentNode.querySelectorAll(
          `.interests-subcategory[type="checkbox"]:checked:not([value="${input.value}"])`
        );
        otherOptions.forEach((option) => {
          option.checked = false;
        });

        const categoryDiv = input.closest(".category");
        const interestsCounter = categoryDiv.querySelector(
          ".counter-interested"
        );
        const notInterestsCounter = categoryDiv.querySelector(
          ".counter-not-interested"
        );
        const neutralCounter = categoryDiv.querySelector(".counter-neutral");
        const selectedInterests = categoryDiv.querySelectorAll(
          '.interests-subcategory[type="checkbox"][value="interested"]:checked'
        );
        const selectedNotInterests = categoryDiv.querySelectorAll(
          '.interests-subcategory[type="checkbox"][value="not_interested"]:checked'
        );
        const selectedNeutral = categoryDiv.querySelectorAll(
          '.interests-subcategory[type="checkbox"][value="neutral"]:checked'
        );

        if (selectedInterests.length > 0) {
          interestsCounter.innerHTML = `${selectedInterests.length}${thumbsUpIcon}`;
        } else {
          interestsCounter.innerHTML = "";
        }

        if (selectedNotInterests.length > 0) {
          notInterestsCounter.innerHTML = `${selectedNotInterests.length}${thumbsDownIcon}`;
        } else {
          notInterestsCounter.innerHTML = "";
        }

        if (selectedNeutral.length > 0) {
          neutralCounter.innerHTML = `${selectedNeutral.length}${neutralIcon}`;
        } else {
          neutralCounter.innerHTML = "";
        }
      });
    });
  }

  // Show the subcategories when the category button is clicked
  const categoryButtons = document.querySelectorAll(".category-buttons");
  categoryButtons.forEach((categoryButton) => {
    categoryButton.addEventListener("click", () => {
      const fieldset = categoryButton.nextElementSibling;
      fieldset.classList.toggle("show-interests-subcategories");
      categoryButton.classList.toggle("open");

      // Close other subcategories
      const otherFieldsets = document.querySelectorAll(
        ".show-interests-subcategories"
      );
      otherFieldsets.forEach((otherFieldset) => {
        if (otherFieldset !== fieldset) {
          otherFieldset.classList.remove("show-interests-subcategories");
          const otherCategoryButton = otherFieldset.previousElementSibling;
          otherCategoryButton.classList.remove("open");
        }
      });
    });
  });

  submitButton.addEventListener("click", (event) => {
    event.preventDefault();
    // Disable the submit button
    submitButton.disabled = true;

    // Get the identifiers for the Custobar data fields
    let interestedInterestsIdentifier = document.querySelector(
      "#interestsFieldName"
    ).value;
    let notInterestedInterestsIdentifier = document.querySelector(
      "#nonInterestsFieldName"
    ).value;
    let eventSourceData = document.querySelector("#eventSource").value;
    let eventType = document.querySelector("#eventType").value;

    // Get all the selected interests from inputs with class "interests-subcategory"
    const interestedInterests = [];
    const neutralInterests = [];
    const notInterestedInterests = [];
    const selectedInputs = document.querySelectorAll(
      '.interests-subcategory[type="checkbox"]:checked'
    );
    selectedInputs.forEach((input) => {
      const interest = {
        name: input.name,
        value: input.value,
      };
      if (input.value === "interested") {
        interestedInterests.push(interest.name);
      } else if (input.value === "neutral") {
        neutralInterests.push(interest.name);
      } else if (input.value === "not_interested") {
        notInterestedInterests.push(interest.name);
      }
    });

    // Create the data object. Neutral interests are not included in the data object.
    let data = {
      source: eventSourceData,
      type: eventType,
      [interestedInterestsIdentifier]: interestedInterests,
      [notInterestedInterestsIdentifier]: notInterestedInterests,
    };

    if (
      interestedInterests.length > 0 ||
      notInterestedInterests.length > 0 ||
      neutralInterests.length > 0
    ) {
      if (typeof custobar !== "undefined") {
        try {
          window.custobar.push(data);
          document.getElementById("submission-feedback").style.display =
            "block";
          form.reset();
          setTimeout(() => {
            window.location.href = "/";
          }, 5000);
        } catch (error) {
          console.error("Error pushing data to custobar:", error);
          showSubmissionError();
        }
      } else {
        // custobar not defined
        showSubmissionError();
      }
    } else {
      // User has not selected any items.
      document.getElementById("no-items-error-message").style.display = "block";
      setTimeout(() => {
        submitButton.disabled = false;
        document.getElementById("no-items-error-message").style.display =
          "none";
      }, 5000);
    }
  });
}
